var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GoBackView'),_c('WebHeaderView'),(_vm.proData)?_c('ProductSwipeView',{attrs:{"lst":_vm.proData.carousel_list}}):_vm._e(),_c('ProductInfo',{attrs:{"item":_vm.proData}}),_c('ProductAuctionLst',{attrs:{"item":_vm.proData}}),(_vm.proData && _vm.proData.shop_info)?_c('ShopView',{attrs:{"shopdata":_vm.proData.shop_info}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }